import { render, staticRenderFns } from "./technicalPoints.vue?vue&type=template&id=778bb426&"
import script from "./technicalPoints.vue?vue&type=script&lang=js&"
export * from "./technicalPoints.vue?vue&type=script&lang=js&"
import style0 from "./technicalPoints.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports